/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlEntityAssetTechOrderBy = {
    EntityId: 'entity_id',
    Asset: 'asset',
    SourceAsset: 'source_asset',
    Port: 'port',
    TechName: 'tech_name',
    Shared: 'shared',
    Found: 'found',
    Created: 'created',
    Updated: 'updated',
    Version: 'version'
} as const;
export type ControlEntityAssetTechOrderBy = typeof ControlEntityAssetTechOrderBy[keyof typeof ControlEntityAssetTechOrderBy];


export function ControlEntityAssetTechOrderByFromJSON(json: any): ControlEntityAssetTechOrderBy {
    return ControlEntityAssetTechOrderByFromJSONTyped(json, false);
}

export function ControlEntityAssetTechOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityAssetTechOrderBy {
    return json as ControlEntityAssetTechOrderBy;
}

export function ControlEntityAssetTechOrderByToJSON(value?: ControlEntityAssetTechOrderBy | null): any {
    return value as any;
}

